import art_city from './svg/art_city.svg';
import bracelet from './svg/bracelet.svg';
import bracelet_card from './svg/bracelet_card.svg';
import bracelet_ppu_card from './svg/bracelet_ppu_card.svg';
import bundle from './svg/bundle.svg';
import bundle_family_pack from './svg/bundle_family_pack.svg';
import bundle_tab from './svg/bundle_tab.svg';
import bundle_train from './svg/bundle_train.svg';
import bundle_travel from './svg/bundle_travel.svg';
import climbing from './svg/climbing.svg';
import enduro from './svg/enduro.svg';
import events from './svg/events.svg';
import experience from './svg/experience.svg';
import ferris_wheel from './svg/ferris_wheel.svg';
import ferry from './svg/ferry.svg';
import food from './svg/food.svg';
import gift from './svg/gift.svg';
import giftcard from './svg/giftcard.svg';
import history_train from './svg/history_train.svg';
import hotel from './svg/hotel.svg';
import hotel_skipass from './svg/hotel_skipass.svg';
import insurance from './svg/insurance.svg';
import kitesurf from './svg/kitesurf.svg';
import lake_trip from './svg/lake_trip.svg';
import lesson from './svg/lesson.svg';
import merchandise from './svg/merchandise.svg';
import museum from './svg/museum.svg';
import padel from './svg/padel.svg';
import parking from './svg/parking.svg';
import ppu from './svg/ppu.svg';
import ppu_card from './svg/ppu_card.svg';
import ppu_fill from './svg/ppu_fill.svg';
import ppu_info from './svg/ppu_info.svg';
import rental from './svg/rental.svg';
import rental_bike from './svg/rental_bike.svg';
import itinerary from './svg/route.svg';
import sea_train from './svg/sea_train.svg';
import seasonal from './svg/seasonal.svg';
import service from './svg/service.svg';
import skipass from './svg/skipass.svg';
import skipass_return from './svg/skipass_return.svg';
import skipass_seasonal from './svg/skipass_seasonal.svg';
import snowitcard from './svg/snowitcard.svg';
import snowitcard_card from './svg/snowitcard_card.svg';
import sport_trekking from './svg/sport_trekking.svg';
import tennis from './svg/tennis.svg';
import ticket from './svg/ticket.svg';
import train from './svg/train.svg';
import transport from './svg/transport.svg';
import yoga from './svg/yoga.svg';

const svgs = {
  'art-city': art_city,
  'bundle~dynamic': bundle,
  'bundle~family-pack': bundle_family_pack,
  'bundle~tab': bundle_tab,
  'bundle~train': bundle_train,
  'bundle~travel': bundle_travel,
  'coupon~giftcard': gift,
  'experience~museum': museum,
  'experience~voucher': ticket,
  'fun-relax': ferris_wheel,
  'history-train': history_train,
  'hotel~coupon': hotel,
  'insurance~travel': insurance,
  'lake-trip': lake_trip,
  'lesson~hotel': hotel_skipass,
  'rental~bike': rental_bike,
  'rental~hotel': hotel_skipass,
  'sci-e-snowboard': rental,
  'sea-train': sea_train,
  'service~free': service,
  'skipass~dynamic': skipass,
  'skipass~hotel': skipass,
  'skipass~membership': ppu,
  'skipass~membership-seasonal': ppu,
  'skipass~return': skipass_return,
  'skipass~seasonal': skipass_seasonal,
  'snow-train': bundle_train,
  'snowitcard~bracelet': bracelet,
  'sport-trekking': sport_trekking,
  'transport~ferry': ferry,
  'transport~train': train,
  'voucher~skipass': skipass,
  'yoga-e-pilates': yoga,
  arrampicata: climbing,
  bracelet_card,
  bracelet_card_membership: bracelet_ppu_card,
  bundle,
  coupon: ticket,
  enduro,
  events,
  experience,
  ferry,
  food,
  gift,
  giftcard,
  gourmet: food,
  hotel: hotel_skipass,
  hotel_2: hotel,
  insurance,
  itinerary,
  kitesurf,
  lesson,
  memberships: ppu,
  memberships_2: ppu_card,
  merchandise,
  padel,
  parking,
  ppu_info,
  ppu_fill,
  puzzle: service,
  rental,
  seasonal,
  service,
  skipass,
  snowitcard,
  snowitcard_2: snowitcard_card,
  tennis,
  ticket,
  train,
  transport,
};

export type SvgProductsList = keyof typeof svgs;
export default svgs;
